import moment from 'moment'
import { format } from './dateFormat'

export const formatDateTime = (date: moment.MomentInput, formatTo = format.shortDateFull, formatFrom?: string) => {
  return date && moment(date, formatFrom).isValid() && date !== '0001-01-01' ? moment(date, formatFrom).format(formatTo) : ('' as string)
}
